import * as React from 'react';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import LoaderComponent from '../Loader';
import AssociatedWorkkardCell from "./associatedWorkkardCell";
import AssociatedWorkkardGroup from "./associatedWorkkardGroup";
import AssociatedWorkkardOrgFilter from "./associatedworkkardOrgFilter";
import ListingComponent from "../ListingComponent";
import Icon from '../../icons';
import AssociatedWorkkardMobileCell from './associatedworkkardMobileCell';
import { useModules } from '../../utils/modules';

import {OrganisationNamesById} from "../../containers/WorkkardDetail/constants";
import Select from '../Select';
import { isMobile } from '../../common/util';

const AssociatedWorkkard = (props) => {
    const { isModuleEnabled } = useModules();

    const [orgFilterValue, setorgFilterValue] = useState(props.associatedWorkkard.orgFilterValue);

    useEffect(() => {
      setorgFilterValue(props.associatedWorkkard.orgFilterValue);
    }, [props.associatedWorkkard.orgFilterValue])

    const getDataByOrgGroup = (data)=> {
        let group, orgGroupData;
        let aWOrgIDGroup=props.orgFilterArray.split(',').map(Number);
        group=data.reduce((acc, obj) => {
            let key;
            if(aWOrgIDGroup.includes(obj.orgId)){
             key=obj.organizationName;
            } else if (aWOrgIDGroup.includes(obj.assigneeOrgId))
            {
                key= OrganisationNamesById[obj.assigneeOrgId];
            }
            if (!acc[key]) {
               acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
         }, {});
        orgGroupData=Object.keys(group).sort().map(key=>({OrgGroup:key,data:group[key]}));
        return orgGroupData;    
    }

    const renderAssociatedWorkkard = (associatedWorkkard) => {
       if( associatedWorkkard?.data?.length > 0)
        {
            const prop = {
              data: props.showAwWithOrg ? getDataByOrgGroup(associatedWorkkard.data) : associatedWorkkard.data,
              cellTemplate: props.showAwWithOrg ? AssociatedWorkkardGroup  : isMobile() ? AssociatedWorkkardMobileCell : AssociatedWorkkardCell,
              onScrollHandler: onScrollHandler,
              onItemClick: (targetRect, id)=>openMiniProfile(targetRect, id),
              type:"div",
              selectedId: '',
              classname:'scrollArea scrollAreaAssociatedWk',
              extraData: { OrgId: props.OrganizationView.Id, isShowOrgCell:props.showAwWithOrg, accessibleOrg:props.accessibleOrg}
            }

            return (
              <ListingComponent {...prop}/>
            );
        }
        return <div className="emptyScreen noDataFound"><Icon name="Emptyowner" className="" />  <br />  <p>No matching result(s) found</p></div> 
    }

    const onScrollHandler = () => {
        const { associatedWorkkard } = props;
        const { skip, take, orgFilterValue} = associatedWorkkard;
        const payload = {
            wkId: props.workkard.Id,
            tmplType: 'HCI',
            selectedFilter: associatedWorkkardFilter?.filter?.[0],
            take : (skip === 0 && take > 20 ) ? 20 : parseInt(take),
            skip: (skip === 0 && take > 20 ) ? take : parseInt(skip)+parseInt(take),
            rows: (skip === 0 && take > 20 ) ? 20 : parseInt(take),
        }
        if(props.showAwWithOrg){
            payload.orgids=orgFilterValue.includes("0") ? props.orgFilterArray:orgFilterValue.map((item,key)=>{return item}).join(",");
        }
        if(skip+take < associatedWorkkard.total){
            props.onAssociatedWorkkardScroll(payload);
        }
    }

    // Api  call  to  get  associated filter when  change  filter
    const changeFilter = (value) => {
        const {orgFilterValue}=props.associatedWorkkard;
        const values = {
            tmplType: 'HCI',
            wkId: props.wkId,
            selectedFilter: value
        }
        if(props.showAwWithOrg){
          values.orgids=orgFilterValue.includes("0") ? props.orgFilterArray:orgFilterValue.map((item,key)=>{return item}).join(",");
          values.orgFilterValue=orgFilterValue;
        }
        props.onAssociatedWorkkardFilterChange(values);
    }

    // open mini profile when click  on user name
    const openMiniProfile = (targetRect, id) => {
        props.showUserInfo({
            target: targetRect,
            userId: id
        });
    }
    
    // prop function to  close associated  workkard  pop  up
    const onClose = ()=> {
        props.onClose();
    }

    const onOrgFilterApply = (e) => {
        var filterOption = [];
        const keys = Object.keys(e);
        let orgFilterId = "0";
        {
        e[keys[0]].options
            .filter((optionData) => optionData.checked === true)
            .forEach((filteredValue) => {
                filterOption = filterOption.concat(filteredValue.value);
            });
        }
        
         const payload = {
            tmplType: 'HCI',
            wkId: props.wkId,
            selectedFilter: associatedWorkkardFilter.filter[0],
            orgids: filterOption.length==0 ? props.orgFilterArray : filterOption.map((item,key)=>{return item}).join(","),
            orgFilterValue: filterOption.length==0 ? orgFilterId :filterOption
        }
        props.onAssociatedWorkkardOrgFilterChange(payload);

    }

    const { associatedWorkkard, associatedWorkkardFilter, isLoading } = props;
    const selectOptions = associatedWorkkardFilter?.data?.map(data => ({label: data, value: data}));

    return (
        <React.Fragment>
            <div className="modalHeader alignMiddle">
                <h1>Associated Workkards ({associatedWorkkard?.total || 0})</h1>
                <a className="close" href="javascript:void(0)" onClick={onClose}><span className="iconRipple"><Icon name="close" className="icon" /></span></a>
            </div>
            <div className="modalBody">
                <div className="filterBlock filterMobile pd__none mb">
                    <div className="filterLeft">
                        <div className="rowFlex alignMiddle">
                            {/* <select className="wth-5" onChange={(e) => changeFilter(e)}>
                                <option disabled>Workkards having same</option>
                                {associatedWorkkardFilter && associatedWorkkardFilter.Data && associatedWorkkardFilter.Data.map((data, key) => {
                                    return (
                                        <option className={data === associatedWorkkardFilter.filter[0] ? 'active' : ''} value={data} key={key} selected={data === associatedWorkkardFilter.filter[0] ? true : undefined}>{data}</option>
                                    );
                                })}
                            </select> */}
                            <div className="matchingAssociate">
                            {isModuleEnabled("workkards.associated_workkard.matching_criteria_policy_number_will_not") && <div className="associatedDetail">
                            <span className="rowFlex">        
                            <span className="label">Workkards matching</span>
                            <Select 
                                    options={selectOptions}
                                    selected={associatedWorkkardFilter?.filter[0]}
                                    onSelect={(value) => changeFilter(value)}
                                    openOnClick={true}
                                    iconName="downArrow"
                                    styleClass="ml"
                                    isOpenRight={false}
                            />
                            <label className="ml mr__b__0 flexGrow breakWord">{associatedWorkkard?.filterValue}</label>
                            </span>
                            
                            </div>}
                                {props.showAwWithOrg && isModuleEnabled("workkards.associated_workkard.filters") && <AssociatedWorkkardOrgFilter orgArray = {props.ogFilterObjArray}  FilterValue={orgFilterValue} onChangeOrgFilter={(e)=>onOrgFilterApply(e)}/>}
                            </div> 
                        </div>
                    </div>
                </div>

                <div className="table associatedParty">
                    <div className="rowFlex tableHead">
                        <ul className="pd__none">
                            <li>Workkard Number</li>
                            <li>Status</li>
                            {props.showAwWithOrg && <li>Organization</li>}
                            <li>Loss Date</li>
                            <li>Loss Type</li>
                            <li>Workkard Owner</li>
                        </ul>
                    </div>
                    <div className="rowFlex tableBody">
                        <div className="poupScroll">
                        {
                            (isLoading && associatedWorkkard.data.length < 1) &&
                            <div>
                                <LoaderComponent  />
                            </div>
                            ||
                            renderAssociatedWorkkard(associatedWorkkard)
                        }
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    workkard: state.workkardDetail.workkardDetail,
    associatedWorkkard: state.workkardDetail.associatedWorkkard,
    OrganizationView: state.sessionContextOidc.organizationView,
    associatedWorkkardFilter: state.workkardDetail.associatedWorkkardFilter,
    isLoading: state.isLoading,
    accessibleOrg:state.sessionContextOidc.combineAccessibleOrgs
});

export default connect(mapStateToProps, null)(AssociatedWorkkard);